import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_APEX: unique symbol = symbolName("apex");
